import { render, staticRenderFns } from "./simple-bold-text.vue?vue&type=template&id=7b05b2e4"
import script from "./simple-bold-text.vue?vue&type=script&lang=js"
export * from "./simple-bold-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports